import { ReactNode } from "react";
import {Moon, Sun} from 'lucide-react';
import { useDarkMode } from "@/hooks/useDarkMode";

/**
 * Wrapper de thème sombre pour les pages de dashboard
 * (candidat, recruteur, organisme).
 *
 * - Ajoute un bouton flottant en haut à droite pour basculer clair/sombre.
 * - Active la classe `dashboard-dark` qui pilote des overrides CSS globaux
 *   (définis dans src/index.css) pour transformer les couleurs claires
 *   (bg-white, bg-gray-50/100/200, text-gray-700/800/900, borders…) en
 *   palette sombre, sans toucher au code des dashboards eux-mêmes.
 *
 * La préférence est persistée dans localStorage et synchronisée entre
 * onglets.
 */
export default function DashboardThemeWrapper({ children }: { children: ReactNode }) {
  const { isDark, toggle } = useDarkMode();

  return (
    <div className={isDark ? "dashboard-dark" : ""}>
      <button
        type="button"
        onClick={toggle}
        aria-label={isDark ? "Passer en mode clair" : "Passer en mode sombre"}
        title={isDark ? "Mode clair" : "Mode sombre"}
        className={`hidden md:inline-flex fixed bottom-5 right-5 z-50 items-center justify-center w-12 h-12 rounded-full shadow-lg ring-1 transition-colors ${
          isDark
            ? "bg-amber-400 text-gray-900 ring-amber-300 hover:bg-amber-300"
            : "bg-gray-900 text-amber-300 ring-gray-700 hover:bg-gray-800"
        }`}
      >
        {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
      </button>
      {children}
    </div>
  );
}
